<template>
    <input :id="inputId" type="text"
           class="text-field"
           v-bind:class="getClass !== null ? inputClass + ' ' + inputId : inputId"
           data-size="s"
           :placeholder="$t(placeHolder)"
           v-model="value"
           @input="onInputChange"
           @focusout="onFocusout"
           :data-invalid="dataInvalid || emptyInput">
</template>

<script>

    import { EventBus } from "../common/event-bus";

    export default {
        name: "inputBox",
        data() {
            return {
                value: "",
                emptyInput: false
            }
        },
        props: {
            prpts: {
                type: Object,
                default: ()=>{return {}}
            },
            inputKey: {
                type: String,
                default: ""
            },
            inputId: {
                type: String,
                default: ""
            },                   // 셀렉트 박스 ID(SPA 페이지에서 로딩된 DOM 중 유일한 값으로 지정할 것)
            inputClass: String,                // Select tag 사용자 정의 Class
            initValue: String,                 // Options key 값이 될  Attribute name
            placeHolder: String,               // PlaceHolder value

        },
        mounted(){
            this.value = typeof(!this.initValue) !== 'undefined' ? this.initValue : ""

            EventBus.$on("changeLocale", e => {
                //console.log("getEvent",$(`#${this.inputId}`))

            });
        },
        computed:{
            dataInvalid: {
                get() {
                    if (this.Common.isEmptyText(this.value)) return false;
                    const TEMPLATE_PROPERTIES = this.constants.TEMPLATE_PROPERTIES;
                    const key = this.inputKey;
                    if (key === TEMPLATE_PROPERTIES.CURRENCY ||
                        key === TEMPLATE_PROPERTIES.TIME ||
                        key === TEMPLATE_PROPERTIES.NUMBER ||
                        key === TEMPLATE_PROPERTIES.PERCENT) {
                        if (this.Common.validNumber(this.value)) {
                            return true;
                        }
                    } else if (key === TEMPLATE_PROPERTIES.AWS_CONFIG ||
                        key === TEMPLATE_PROPERTIES.TAG) {
                        if (this.prpts[key] && this.prpts[key].slt.length < 1) {
                            return true
                        }
                    }
                    return false;
                }
            },
            getClass:function(){
                return typeof(this.inputClass) !== 'undefined' ? this.inputClass : null
            }
        },
        watch: {
            value(newVal, olv) {
                this.emptyInput = false;
                if (this.Common.isEmptyText(newVal) && !this.Common.isEmptyText(olv)) {
                    this.emptyInput = true;
                }
            }
        },
        methods: {
            onInputChange() {
                this.$emit('onInputChange', {'id': this.inputId, 'value': this.value});
            },
            onFocusout() {
                // 
            }
        }
    }
</script>



// WEBPACK FOOTER //
// src/components/common/InputBoxC.vue